/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_haiku_valid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ This is a 5-7-5 haiku!`)
};

const es_syl_haiku_valid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ ¡Esto es un haiku 5-7-5!`)
};

const de_syl_haiku_valid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ Das ist ein 5-7-5-Haiku!`)
};

const nl_syl_haiku_valid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ Dit is een 5-7-5 haiku!`)
};

const fr_syl_haiku_valid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ C'est un haïku 5-7-5 !`)
};

const it_syl_haiku_valid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ Questo è un haiku 5-7-5!`)
};

const pt_br2_syl_haiku_valid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ Isso é um haiku 5-7-5!`)
};

const pt_syl_haiku_valid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ Isto é um haiku 5-7-5!`)
};

const ja_syl_haiku_valid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ これは5-7-5の俳句です！`)
};

const zh_syl_haiku_valid = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ 这是一首5-7-5俳句！`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_haiku_valid = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_haiku_valid(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_haiku_valid", locale)
	if (locale === "en") return en_syl_haiku_valid(inputs)
	if (locale === "es") return es_syl_haiku_valid(inputs)
	if (locale === "de") return de_syl_haiku_valid(inputs)
	if (locale === "nl") return nl_syl_haiku_valid(inputs)
	if (locale === "fr") return fr_syl_haiku_valid(inputs)
	if (locale === "it") return it_syl_haiku_valid(inputs)
	if (locale === "pt-BR") return pt_br2_syl_haiku_valid(inputs)
	if (locale === "pt") return pt_syl_haiku_valid(inputs)
	if (locale === "ja") return ja_syl_haiku_valid(inputs)
	return zh_syl_haiku_valid(inputs)
};